import TopAppBar from '../global/TopBar';
import TaskSideBar from '../global/TaskSideBar';
import { Box, Typography, useTheme} from '@mui/material';
import { tokens } from "../../theme";


const TaskFrame = ({children}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box className="w-100 flex-raw" overflow={'hidden'}>
      <TaskSideBar />
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        flex: 1,
        minWidth: 0 // Prevents flex items from overflowing
      }}>
        <TopAppBar />
        <Box 
          sx={{ 
            flex: 1,
            overflow: 'auto',
            p: 2
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default TaskFrame;